import { render, staticRenderFns } from "./CheckPrice.vue?vue&type=template&id=1b9cd48a"
import script from "./CheckPrice.vue?vue&type=script&lang=js"
export * from "./CheckPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports